// Ambiente di PRODUZIONE.
// I valori specifici del cliente NON vanno scritti qui: stanno in
// src/client.config.json (vedi src/app/core/config/client.config.ts).

import { CLIENT } from '../app/core/config/client.config';

export const environment = {
  production: true,
  companyId: CLIENT.api.companyId,
  defaultauth: 'fackbackend',
  // Stessa origine dell'app: la Pages Function in functions/api/[[path]].js
  // inoltra /api verso il backend Spring configurato in client.config.json.
  urlapi: CLIENT.api.basePath,
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};
